import { HOW_TO_PLAY_PAGES } from "app/how-to-play/how-to-play-pages";
import HowToPlaySlide from "app/how-to-play/HowToPlaySlide";
import FullScreenPanel from "app/ui/FullScreenPanel";
import MenuButton from "app/ui/MenuButton";
import cn from "app/util/classnames";
import { useState } from "react";

interface HowToPlayProps {
  onDismiss?: () => void;
}

export default function HowToPlay(props: HowToPlayProps) {
  const [slideIndex, setSlideIndex] = useState<number>(0);
  const isFirstSlide = slideIndex === 0;
  const lastSlideIndex = HOW_TO_PLAY_PAGES.length - 1;
  const isLastSlide = slideIndex === lastSlideIndex;

  function dismiss() {
    props.onDismiss?.();
  }

  function goToIndex(number: number) {
    setSlideIndex(number);
  }

  return (
    <FullScreenPanel
      panelClassName="md:h-[80%] md:min-h-140 md:max-h-158"
      childDivClassName="flex-1 overflow-y-clip"
      onClose={() => dismiss()}
      heading="How to Play"
    >
      <div // Main flex box
        className="flex-1 w-full flex flex-col"
      >
        <div // Page number holder
          className={cn(
            "flex flex-col items-center justify-start gap-0.5",
            "mb-1.5 text-center",
          )}
        >
          <p className="text-sm">{slideIndex + 1} / 7</p>
        </div>
        <div // Main section
          className="flex-1 flex justify-center"
        >
          {HOW_TO_PLAY_PAGES.map(({ ImgContent, TextContent }, pageIndex) => (
            <HowToPlaySlide
              key={pageIndex}
              imgContent={ImgContent}
              textContent={TextContent}
              active={slideIndex === pageIndex}
            ></HowToPlaySlide>
          ))}
        </div>
        <div // Button container
          className={cn(
            "flex-none mt-1 pt-6 lg:p-0",
            "flex items-end justify-center gap-2.5",
          )}
        >
          {!isFirstSlide && (
            <MenuButton
              className="max-w-30"
              onClick={() => {
                goToIndex(Math.max(slideIndex - 1, 0));
              }}
            >
              Back
            </MenuButton>
          )}
          {isLastSlide && (
            <MenuButton className="max-w-30" onClick={() => dismiss()}>
              Close
            </MenuButton>
          )}
          {!isLastSlide && (
            <MenuButton
              className="max-w-30"
              onClick={() =>
                goToIndex(Math.min(slideIndex + 1, lastSlideIndex))
              }
            >
              Next
            </MenuButton>
          )}
        </div>
      </div>
    </FullScreenPanel>
  );
}
